import React, { Component } from "react";
import { Switch, Route, NavLink } from "react-router-dom";
import Pending from "./Pending";
import Completed from "./Completed";
import { withRouter } from "react-router";
import Update from "./Update";
import KeyDropdownValue from "../shared/KeyDropdownValue";
import InputKeyValue from "../shared/InputKeyValue";
import Modal from "../shared/Modal";
import { Search } from "../normalizer";

class SaleAttribution extends Component {
  state = {
    showUpdateModal: false, selectedAttribution: null, preSelectedUser: null,
    filterFrom: null,
    filterTo: null,
    filterContract: '',
    pendingRefreshKey: 0,
  };

  dropNavOptions = [
    {
      label: "Atribuição de contrato",
      to: "/sale-attributions/pending",
    },
    {
      label: "Troca de contrato",
      to: "/sale-trading/requested",
    },
  ];

  handleDropdownChange = (option) => {
    this.props.history.push(option.to);
  };

  openUpdateModal = (attribution, user) => this.setState({ showUpdateModal: true, selectedAttribution: attribution, preSelectedUser: user || null });
  closeUpdateModal = () => this.setState({ showUpdateModal: false, selectedAttribution: null, preSelectedUser: null });
  // Called by UpdateAttributionContainer on successful submit: closes the modal
  // and bumps pendingRefreshKey so <Pending> remounts and re-fetches its list.
  handleUpdateSuccess = () => {
    this.closeUpdateModal();
    this.setState(function(prevState) { return { pendingRefreshKey: prevState.pendingRefreshKey + 1 }; });
  };

  handleContractChange = (e) => this.setState({ filterContract: e.target.value });
  handleFromChange = (date) => this.setState({ filterFrom: date });
  handleToChange = (date) => this.setState({ filterTo: date });

  formatDate = (date) => date ? date.toISOString().split('T')[0] : '';

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ showUpdateModal: false });
    }
  }

  render() {
    const { campaignUser, history } = this.props;
    const { filterFrom, filterTo, filterContract, pendingRefreshKey } = this.state;

    if (!campaignUser.canSeeSaleAttributions) {
      return null;
    }

    return (
      <div className="contracts-layout">
        <div className="contracts-layout-header">
          <h4 className="contracts-layout-header-title">Contratos</h4>
        </div>
        <div className="contracts-layout-options">
          <div className="contracts-layout-options-drop">
            <KeyDropdownValue
              className="contracts-layout-options-drop-select"
              options={this.dropNavOptions}
              optionsLabel="label"
              optionsId="to"
              selectedValue={this.dropNavOptions[0]}
              onChange={this.handleDropdownChange}
              placeholder="Selecione"
            />
          </div>
        </div>

        <nav className="contracts-layout-navigation">
          <NavLink
            exact
            to={"/sale-attributions/pending"}
            activeClassName="contracts-layout-navigation-item-active"
            className="contracts-layout-navigation-item"
          >
            Contratos por atribuir
          </NavLink>
          <NavLink
            exact
            to={"/sale-attributions/completed"}
            activeClassName="contracts-layout-navigation-item-active"
            className="contracts-layout-navigation-item"
          >
            Contratos atribuídos
          </NavLink>
        </nav>
        <div className="contracts-layout-filters">
          <div className="contracts-layout-filters-search">
            <InputKeyValue
              title="Contrato"
              leftIcon={<Search />}
              className="contracts-layout-filters-search-input"
              type="text"
              name="contract"
              placeholder="Pesquisar contrato"
              value={filterContract}
              onChange={this.handleContractChange}
            />
          </div>
          <div className="contracts-layout-filters-from">
            <InputKeyValue
              title="Data início contrato"
              className="contracts-layout-filters-from-input"
              type="date"
              name="from"
              placeholder="dd/mm/aaaa"
              value={filterFrom}
              onChange={this.handleFromChange}
            />
          </div>
          <div className="contracts-layout-filters-to">
            <InputKeyValue
              title="Data fim contrato"
              className="contracts-layout-filters-to-input"
              type="date"
              name="to"
              placeholder="dd/mm/aaaa"
              value={filterTo}
              onChange={this.handleToChange}
            />
          </div>
        </div>
        <Switch>
          <Route
            path="/sale-attributions/pending"
            render={(routeProps) => (
              <Pending
                key={pendingRefreshKey}
                {...routeProps}
                onOpenUpdate={this.openUpdateModal}
                filterFrom={this.formatDate(filterFrom)}
                filterTo={this.formatDate(filterTo)}
                filterContract={filterContract}
              />
            )}
          />
          <Route
            path="/sale-attributions/completed"
            render={(routeProps) => (
              <Completed
                {...routeProps}
                filterFrom={this.formatDate(filterFrom)}
                filterTo={this.formatDate(filterTo)}
                filterContract={filterContract}
              />
            )}
          />
        </Switch>

        <Modal
          show={this.state.showUpdateModal}
          untoggle={this.closeUpdateModal}
        >
          <Update history={history} onClose={this.closeUpdateModal} onSuccess={this.handleUpdateSuccess} attribution={this.state.selectedAttribution} preSelectedUser={this.state.preSelectedUser} />
        </Modal>
      </div>
    );
  }
}
export default withRouter(SaleAttribution);
